import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationProvider";

import OnboardingStepHeader from "./OnboardingStepHeader";
import Sallie from "../UIComponents/Sallie";
import SubmitButton from "../UIComponents/SubmitButton";
import LoadingSpinner from "../UIComponents/LoadingSpinner";

import { checkEmailToken, sendConfirmEmail, deleteEmailToken } from "../../api/helpReq";

const EmailConfirm = ({ setOnboardingPercent, user }) => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    if (!user) {
      history.push("/");
      return;
    }
  }, [user, history]);

  const url = new URLSearchParams(location.search);
  const token = url.get("token");

  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reSendEmail = () => {
    const { firstName, lastName, email } = user;
    sendConfirmEmail({ email, name: firstName + " " + lastName });
    history.push("/Verification/EmailSent");
  };

  const clickHandler = async () => {
    try {
      setSubmitting(true);
      deleteEmailToken();
      history.push("/");
    } catch (err) {
      setSubmitting(false);
      history.push("/oops");
    }
  };

  useEffect(() => {
    setOnboardingPercent(90);
    checkEmailToken({ token })
      .then((res) => {
        if (res.status !== 200) setError(true);
        setLoading(false);
      })
      .catch((e) => {
        console.log("token is not matched", e);
        setError(true);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <OnboardingStepHeader text={t("emailconfirm.header")} />
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <>
          <Sallie text={t("emailconfirm.error")} variant="sad" />
          <SubmitButton disabled={submitting} onClick={reSendEmail}>
            {t("emailconfirm.resend")}
          </SubmitButton>
        </>
      ) : (
        <>
          <Sallie text={t("emailconfirm.verified")} />
          <SubmitButton disabled={submitting} onClick={clickHandler}>
            {t("emailconfirm.go_to_dashboard")}
          </SubmitButton>
        </>
      )}
    </>
  );
};

export default EmailConfirm;